import { createTheme } from '@mantine/core';
import { SCROLLBAR_SIZE, SCROLLBAR_THUMB } from './scrollbarSize';

// Option lists in Mantine show a 4px bar only while scrolling; give them the shared one, on hover.
const OPTIONS_SCROLL = { scrollAreaProps: { scrollbarSize: SCROLLBAR_SIZE, type: 'hover' } };

export const theme = createTheme({
  // Filled buttons carry white text: blue-6 gives 3.6:1, blue-8 4.8:1. Light mode keeps 6.
  primaryShade: { light: 6, dark: 8 },
  fontFamily: 'Roboto',
  cursorType: 'pointer',
  components: {
    // Mantine pads the bar by a fifth of its size; this keeps its thumb as wide as everywhere else.
    ScrollArea: {
      defaultProps: { scrollbarSize: SCROLLBAR_SIZE },
      styles: { scrollbar: { padding: (SCROLLBAR_SIZE - SCROLLBAR_THUMB) / 2 } }
    },
    Select: { defaultProps: OPTIONS_SCROLL },
    MultiSelect: { defaultProps: OPTIONS_SCROLL },
    Autocomplete: { defaultProps: OPTIONS_SCROLL },
    TagsInput: { defaultProps: OPTIONS_SCROLL },
    Button: {
      styles: (theme, params) => ({
        root: {
          ...(params.size === 'sm' && {
            minHeight: '32px',
            height: '32px',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: '400'
          })
        }
      })
    }
  }
});
